const en = {
  // 页面标题
  pageTitle: "Wevoov Account Deletion Service",
  pageSubtitle: "Wevoov User Account Deletion Platform",
  
  // 步骤标题（用于步骤条）
  step1Title: "Enter ID",
  step2Title: "Confirm", 
  step3Title: "Verify",
  step4Title: "Complete",
  
  // 步骤描述
  step1Desc: "Verify Identity",
  step2Desc: "Send Code",
  step3Desc: "Confirm Deletion",
  step4Desc: "Success",
  
  // 完整步骤标题（用于内容区域）
  step1FullTitle: "Step 1: Enter User ID",
  step2FullTitle: "Step 2: Confirm Information", 
  step3FullTitle: "Step 3: Enter Verification Code",
  step4FullTitle: "Deletion Complete",
  
  // 第一步
  step1Instruction: "Please enter the user ID you want to delete, we will verify your identity",
  userIdPlaceholder: "Enter user ID",
  getUserInfoButton: "Get User Info",
  
  // 第二步
  step2Instruction: "After confirming the above user information is correct, click the button below to send verification code to your Wevoov App",
  userInfoLabel: "User ID",
  sendCodeButton: "Send Verification Code",
  
  // 第三步
  step3Instruction: "Please open your Wevoov App to check the verification code, then enter the code below to complete account deletion",
  codePlaceholder: "Enter verification code",
  confirmDeleteButton: "Confirm Account Deletion",
  
  // 第四步
  successTitle: "Account Deletion Successful!",
  successSubtitle: "Your account information has been successfully deleted. Thank you for using our service",
  restartButton: "Start Over",
  
  // 消息提示
  messages: {
    enterUserId: "Please enter user ID",
    getUserInfoSuccess: "User information retrieved successfully",
    getUserInfoFailed: "Failed to get user information",
    sendCodeSuccess: "Verification code sent successfully! Please open Wevoov App to check",
    sendCodeFailed: "Failed to send verification code",
    enterCode: "Please enter verification code",
    deleteSuccess: "Account deletion successful!",
    deleteFailed: "Account deletion failed",
    networkTimeout: "Request timeout, please check network connection",
    networkError: "Network connection failed, please check network settings",
    retryNetwork: "Retrying network connection...",
    networkNormal: "Network connection normal",
    networkStillFailed: "Network connection still failed"
  },
  
  // 网络错误
  networkErrorTitle: "Network Connection Error",
  networkErrorDesc: "Unable to connect to server, please check network connection and retry",
  retryButton: "Retry",
  
  // 按钮
  buttons: {
    retry: "Retry",
    restart: "Start Over"
  }
};

export default en; 